export default function SustainabilitySection() {
  return (
    <>
      {/* Sustainability Banner */}
      <section id="sustainability" className="relative w-full h-96 overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/be6e99910c88e8686028d82b439d8cff.jpg"
          alt="Sustainability — empowering communities"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0c1f38]/75 via-[#0c1f38]/40 to-transparent" />
        <div className="absolute inset-0 flex items-center">
          <div className="max-w-7xl mx-auto px-6 lg:px-10 w-full">
            <p className="text-[#d4571a] text-xs font-bold tracking-widest uppercase mb-3">
              Sustainability
            </p>
            <h2 className="text-white text-3xl lg:text-4xl font-bold max-w-sm leading-tight mb-5">
              Our Approach to<br />Sustainability
            </h2>
            <p className="text-white/80 text-sm max-w-xs leading-relaxed mb-7">
              Energising growth by responsibly empowering people, communities and businesses.
            </p>
          </div>
        </div>
      </section>

      {/* Community Description */}
      <section className="bg-white pt-16 pb-4">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <p className="text-gray-600 text-base leading-relaxed">
            At NRG Trading, the communities we operate in are at the heart of everything we do. We believe that
            responsible, transparent trading is a force for lasting good — fostering economic resilience,
            environmental stewardship, and shared prosperity for generations to come.
          </p>
        </div>
      </section>

      {/* CEO Quote */}
      <section className="bg-white py-16">
        <div className="max-w-3xl mx-auto px-6 text-center">
          {/* Drop icon */}
          <div className="w-10 h-10 flex items-center justify-center mx-auto mb-8">
            <i className="ri-drop-line text-[#0c1f38] text-3xl" />
          </div>
          <blockquote className="text-[#0c1f38] text-xl lg:text-2xl font-light leading-relaxed italic">
            At NRG Trading, we do more than trade energy&mdash;we help power global
            progress by delivering safe, dependable solutions that support people, communities, and businesses.
          </blockquote>
        </div>
      </section>

      {/* Purpose & Leadership Cards */}
      <section className="bg-[#f5f7fa] py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Purpose Card */}
            <div className="relative rounded-lg overflow-hidden h-80 group cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=oil%20tanker%20ship%20passing%20under%20suspension%20bridge%20at%20golden%20hour%2C%20industrial%20maritime%20energy%20transport%2C%20dramatic%20warm%20sunset%20sky%20reflection%20on%20water%2C%20cinematic%20photography&width=700&height=500&seq=purpose1&orientation=landscape"
                alt="Purpose"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0c1f38]/80 via-[#0c1f38]/30 to-transparent" />
              <div className="absolute bottom-0 left-0 p-7">
                <p className="text-[#d4571a] text-xs font-bold tracking-widest uppercase mb-2">Purpose</p>
                <h3 className="text-white text-2xl font-bold leading-tight mb-3">
                  Energising<br />Growth
                </h3>
                <p className="text-white/70 text-sm leading-relaxed max-w-xs">
                  We support the global energy system by responsibly delivering reliable, secure, and
                  increasingly clean energy to the people, communities and businesses that need it most.
                </p>
              </div>
            </div>

            {/* Leadership Card */}
            <div className="relative rounded-lg overflow-hidden h-80 group cursor-pointer">
              <img
                src="https://images.unsplash.com/photo-1486325212027-8081e485255e?w=700&h=500&fit=crop&crop=top"
                alt="Leadership"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0c1f38]/80 via-[#0c1f38]/30 to-transparent" />
              <div className="absolute bottom-0 left-0 p-7">
                <p className="text-[#d4571a] text-xs font-bold tracking-widest uppercase mb-2">Leadership</p>
                <h3 className="text-white text-2xl font-bold leading-tight mb-3">
                  Strong Corporate<br />Governance
                </h3>
                <p className="text-white/70 text-sm leading-relaxed max-w-xs">
                  Our strategic direction is underpinned by a strong corporate governance framework that ensures accountability, transparency, and responsible decision-making.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
